var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "login__main"
  }, [_c('section', [_c('h1', {
    staticClass: "login__title"
  }, [_vm._v("\n      " + _vm._s(_vm.hideSocialLogins ? _vm.$t('login.continueWithApplication') : _vm.showOtpInput ? _vm.$t('login.loginOnly') : _vm.$t('login.loginOrSignup')) + "\n    ")]), _vm._v(" "), !_vm.showGoogleComplete && !_vm.showOtpInput ? [_c('div', {
    staticClass: "login__body",
    class: {
      'login__body--email-only': _vm.hideSocialLogins
    }
  }, [_c('div', {
    staticClass: "login__email-section"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.loginUser.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "login__field"
  }, [_c('label', {
    attrs: {
      "for": "emailinput"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "login__input-wrapper"
  }, [_c('i', {
    staticClass: "pi pi-envelope"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    class: {
      'p-invalid': _vm.submitTried && (_vm.email === '' || _vm.emailError)
    },
    attrs: {
      "id": "emailinput",
      "aria-describedby": "emailinput-help",
      "type": "text",
      "autocomplete": "username webauthn",
      "placeholder": _vm.$t('login.emailPlaceholder').toString()
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.email = $event.target.value;
      }, function ($event) {
        _vm.submitTried = false;
      }]
    }
  })]), _vm._v(" "), _vm.submitTried && (_vm.email === '' || _vm.emailError) ? _c('small', {
    staticClass: "login__error"
  }, [_vm._v("\n                " + _vm._s(_vm.email === '' ? _vm.$t('login.emailRequired') : _vm.emailError) + "\n              ")]) : _vm._e()]), _vm._v(" "), _vm.error ? _c('small', {
    staticClass: "login__error login__error--center",
    domProps: {
      "textContent": _vm._s(_vm.error)
    }
  }) : _vm._e(), _vm._v(" "), _c('Button', {
    staticClass: "login__submit-btn",
    class: {
      'login__submit-btn-centered': !_vm.showOtpInput
    },
    attrs: {
      "label": _vm.$t('login.continue'),
      "type": "submit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login__other-method",
    domProps: {
      "textContent": _vm._s(_vm.$t('login.accessWithOtp'))
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.loginWithOtherMethod.apply(null, arguments);
      }
    }
  })], 1)]), _vm._v(" "), !_vm.hideSocialLogins ? _c('div', {
    staticClass: "login__divider"
  }) : _vm._e(), _vm._v(" "), !_vm.hideSocialLogins ? _c('div', {
    staticClass: "login__social-section"
  }, [_c('Button', {
    staticClass: "login__social-btn login__social-btn--google",
    attrs: {
      "loading": _vm.googleLoading,
      "disabled": _vm.googleLoading
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.loginGoogle.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "pi pi-google"
  }), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "login__social-prefix"
  }, [_vm._v(_vm._s(_vm.$t('login.continueWith')))]), _vm._v(" "), _c('strong', [_vm._v("Google")])])]), _vm._v(" "), _c('Button', {
    staticClass: "login__social-btn login__social-btn--linkedin",
    attrs: {
      "loading": _vm.linkedinLoading,
      "disabled": _vm.linkedinLoading
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.loginLinkedIn.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "pi pi-linkedin"
  }), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "login__social-prefix"
  }, [_vm._v(_vm._s(_vm.$t('login.continueWith')))]), _vm._v(" "), _c('strong', [_vm._v("LinkedIn")])])]), _vm._v(" "), _c('Button', {
    staticClass: "login__social-btn login__social-btn--facebook",
    attrs: {
      "loading": _vm.facebookLoading,
      "disabled": _vm.facebookLoading
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.loginFacebook.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "pi pi-facebook"
  }), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "login__social-prefix"
  }, [_vm._v(_vm._s(_vm.$t('login.continueWith')))]), _vm._v(" "), _c('strong', [_vm._v("Facebook")])])]), _vm._v(" "), _c('Button', {
    staticClass: "login__social-btn login__social-btn--apple",
    nativeOn: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.loginApple();
      }
    }
  }, [_c('i', {
    staticClass: "pi pi-apple"
  }), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "login__social-prefix"
  }, [_vm._v(_vm._s(_vm.$t('login.continueWith')))]), _vm._v(" "), _c('strong', [_vm._v("ID Apple")])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "login__disclaimer"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.continueWithTems'))
    }
  })])] : _vm.showOtpInput && !_vm.showGoogleComplete ? [_c('div', {
    staticClass: "login__otp-view"
  }, [_c('p', {
    staticClass: "login__otp-message"
  }, [_vm._v("\n          " + _vm._s(_vm.otpMessage) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "login__otp-inputs"
  }, [_c('OtpInput', {
    ref: "otpInput",
    attrs: {
      "error": _vm.submitTried && (_vm.otp === '' || !!_vm.otpError),
      "disabled": false
    },
    on: {
      "input": _vm.handleOtpInput,
      "complete": _vm.handleOtpComplete
    },
    model: {
      value: _vm.otp,
      callback: function ($$v) {
        _vm.otp = $$v;
      },
      expression: "otp"
    }
  })], 1), _vm._v(" "), _vm.submitTried && _vm.otp === '' ? _c('small', {
    staticClass: "login__error login__error--center",
    domProps: {
      "textContent": _vm._s(_vm.$t('login.otpRequired'))
    }
  }) : _vm._e(), _vm._v(" "), _vm.otpError ? _c('small', {
    staticClass: "login__error login__error--center",
    domProps: {
      "textContent": _vm._s(_vm.otpError)
    }
  }) : _vm._e(), _vm._v(" "), _vm.error ? _c('small', {
    staticClass: "login__error login__error--center",
    domProps: {
      "textContent": _vm._s(_vm.error)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login__otp-actions"
  }, [_c('Button', {
    staticClass: "login__submit-btn",
    attrs: {
      "label": _vm.$t('login.continue')
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.loginUser.apply(null, arguments);
      }
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "login__resend-btn",
    attrs: {
      "label": _vm.$t('login.resendCode'),
      "disabled": _vm.resendingOtp || _vm.otpRemainingTime > 0
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.resendOtp.apply(null, arguments);
      }
    }
  })], 1), _vm._v(" "), _vm.otpRemainingTime > 0 ? _c('p', {
    staticClass: "login__otp-timer"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('login.codeExpiresIn', {
    time: _vm.formatOtpTime
  })) + "\n        ")]) : _c('p', {
    staticClass: "login__otp-expired"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('login.otpExpired')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "login__change-email",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeEmail
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('login.changeEmail')) + "\n        ")]), _vm._v(" "), _vm.otpMethod === 'sms' || _vm.otpMethod === 'whatsapp' ? _c('Button', {
    staticClass: "login__switch-method",
    attrs: {
      "label": _vm.$t('login.sendViaEmail'),
      "disabled": _vm.resendingOtp
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.switchToEmail.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login__disclaimer"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.continueWithTems'))
    }
  })])], 1)] : [_c('div', {
    staticClass: "back-link-google",
    on: {
      "click": _vm.cancelGoogleSignup
    }
  }, [_c('i', {
    staticClass: "pi pi-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('signup.back')))])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('login.loginOrSignup')))]), _vm._v(" "), _c('div', {
    staticClass: "login__content login google-complete"
  }, [_c('div', {
    staticClass: "google-complete__header"
  }, [_c('i', {
    class: ['pi', _vm.socialProviderIcon]
  }), _vm._v(" "), _c('p', {
    staticClass: "google-complete__title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('signup.completeProfile')) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "google-complete__description"
  }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.socialProviderDataInfoKey)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "google-complete__user-info"
  }, [!_vm.nameFieldsEditable && _vm.googleFirstName && _vm.googleLastName ? _c('div', {
    staticClass: "user-info-item"
  }, [_c('i', {
    staticClass: "pi pi-user"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.googleFirstName) + " " + _vm._s(_vm.googleLastName))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-info-item"
  }, [_c('i', {
    staticClass: "pi pi-envelope"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.googleEmail))])])]), _vm._v(" "), _c('form', {
    staticClass: "google-complete__form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.completeSocialSignup.apply(null, arguments);
      }
    }
  }, [_vm.nameFieldsEditable ? _c('div', {
    staticClass: "name-fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.$t('signup.firstName')) + "*")]), _vm._v(" "), _c('InputText', {
    class: {
      'p-invalid': _vm.submitTried && !_vm.googleFirstName
    },
    attrs: {
      "id": "firstName",
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('signup.firstNamePlaceholder')
    },
    model: {
      value: _vm.googleFirstName,
      callback: function ($$v) {
        _vm.googleFirstName = $$v;
      },
      expression: "googleFirstName"
    }
  }), _vm._v(" "), _vm.submitTried && !_vm.googleFirstName ? _c('small', {
    staticClass: "p-error"
  }, [_vm._v(_vm._s(_vm.$t('signup.fieldRequired')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.$t('signup.lastName')) + "*")]), _vm._v(" "), _c('InputText', {
    class: {
      'p-invalid': _vm.submitTried && !_vm.googleLastName
    },
    attrs: {
      "id": "lastName",
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('signup.lastNamePlaceholder')
    },
    model: {
      value: _vm.googleLastName,
      callback: function ($$v) {
        _vm.googleLastName = $$v;
      },
      expression: "googleLastName"
    }
  }), _vm._v(" "), _vm.submitTried && !_vm.googleLastName ? _c('small', {
    staticClass: "p-error"
  }, [_vm._v(_vm._s(_vm.$t('signup.fieldRequired')))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('client-only', [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('settings.phoneNumber')) + " *")]), _vm._v(" "), _c('VuePhoneNumberInput', {
    attrs: {
      "translations": _vm.$t('settings.phone'),
      "fetch-country": true,
      "required": "",
      "error": _vm.submitTried && (!_vm.socialPhoneNumber || !_vm.socialPhoneIsValid)
    },
    on: {
      "update": _vm.updateSocialPhoneNumber
    },
    model: {
      value: _vm.socialPhoneNumber,
      callback: function ($$v) {
        _vm.socialPhoneNumber = $$v;
      },
      expression: "socialPhoneNumber"
    }
  }), _vm._v(" "), _vm.submitTried && !_vm.socialPhoneNumber ? _c('small', [_vm._v(_vm._s(_vm.$t('signup.fieldRequired')))]) : _vm.submitTried && !_vm.socialPhoneIsValid ? _c('small', [_vm._v(_vm._s(_vm.$t('settings.phoneNotValid')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "policy",
    staticStyle: {
      "margin-top": "1rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.terms1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "id": "googleTerms2",
      "binary": true
    },
    model: {
      value: _vm.terms2,
      callback: function ($$v) {
        _vm.terms2 = $$v;
      },
      expression: "terms2"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "googleTerms2"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.terms2'))
    }
  })], 1), _vm._v(" "), _vm.error ? _c('small', {
    staticStyle: {
      "margin": "auto"
    },
    domProps: {
      "textContent": _vm._s(_vm.error)
    }
  }) : _vm._e(), _vm._v(" "), _c('Button', {
    staticClass: "complete-button",
    attrs: {
      "label": _vm.$t('signup.completeSignup'),
      "loading": _vm.socialSignupLoading,
      "disabled": _vm.socialSignupLoading
    },
    on: {
      "click": _vm.completeSocialSignup
    }
  })], 1)])]], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }